/* tslint:disable */
/* eslint-disable */
/**
 * Poizon API
 * ### Poizon API Documentation  **Официальная документация Poizon API.**  #### 📚 Ресурсы  - [Официальный GitHub SDK](https://github.com/Poizon-API/public-api)  - [OpenApi JSON](https://poizon-api.com/api/poizon-ru/api-json)
 *
 * The version of the OpenAPI document: 2.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { BrandListResponseDto } from '../models';
// @ts-ignore
import type { ProductInfoResponseDto } from '../models';
// @ts-ignore
import type { SearchResponseDto } from '../models';
// @ts-ignore
import type { SizeTableResponseDto } from '../models';
/**
 * PoizonApiApi - axios parameter creator
 * @export
 */
export const PoizonApiApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Получение списка брендов
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        poizonApiControllerGetBrandList: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/poizon-api/brand-list`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication x-api-key required
            await setApiKeyToObject(localVarHeaderParameter, "x-api-key", configuration)

            // authentication accessToken required

            // authentication x-service-api-key required
            await setApiKeyToObject(localVarHeaderParameter, "x-service-api-key", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Получение информации о товаре
         * @param {number} spuId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        poizonApiControllerGetProductInfo: async (spuId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'spuId' is not null or undefined
            assertParamExists('poizonApiControllerGetProductInfo', 'spuId', spuId)
            const localVarPath = `/poizon-api/product-info/{spuId}`
                .replace(`{${"spuId"}}`, encodeURIComponent(String(spuId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication x-api-key required
            await setApiKeyToObject(localVarHeaderParameter, "x-api-key", configuration)

            // authentication accessToken required

            // authentication x-service-api-key required
            await setApiKeyToObject(localVarHeaderParameter, "x-service-api-key", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Получение размерной сетки
         * @param {number} spuId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        poizonApiControllerGetSizeTable: async (spuId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'spuId' is not null or undefined
            assertParamExists('poizonApiControllerGetSizeTable', 'spuId', spuId)
            const localVarPath = `/poizon-api/size-table/{spuId}`
                .replace(`{${"spuId"}}`, encodeURIComponent(String(spuId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication x-api-key required
            await setApiKeyToObject(localVarHeaderParameter, "x-api-key", configuration)

            // authentication accessToken required

            // authentication x-service-api-key required
            await setApiKeyToObject(localVarHeaderParameter, "x-service-api-key", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Поиск товаров
         * @param {string} [keyword] Search keyword (full-text по названиям). Опционально — можно искать только по brandIds/categoryIds.
         * @param {number} [page] Page number
         * @param {number} [pageSize] Page size
         * @param {Array<number>} [fitIds] Fit IDs
         * @param {PoizonApiControllerSearchSortTypeEnum} [sortType] 
         * @param {PoizonApiControllerSearchSortModeEnum} [sortMode] Sort mode
         * @param {Array<number>} [priceRange] Price range (min, max)
         * @param {Array<number>} [brandIds] Brand IDs
         * @param {Array<number>} [categoryIds] Category IDs
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        poizonApiControllerSearch: async (keyword?: string, page?: number, pageSize?: number, fitIds?: Array<number>, sortType?: PoizonApiControllerSearchSortTypeEnum, sortMode?: PoizonApiControllerSearchSortModeEnum, priceRange?: Array<number>, brandIds?: Array<number>, categoryIds?: Array<number>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/poizon-api/search`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication x-api-key required
            await setApiKeyToObject(localVarHeaderParameter, "x-api-key", configuration)

            // authentication accessToken required

            // authentication x-service-api-key required
            await setApiKeyToObject(localVarHeaderParameter, "x-service-api-key", configuration)

            if (keyword !== undefined) {
                localVarQueryParameter['keyword'] = keyword;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['pageSize'] = pageSize;
            }

            if (fitIds) {
                localVarQueryParameter['fitIds'] = fitIds;
            }

            if (sortType !== undefined) {
                localVarQueryParameter['sortType'] = sortType;
            }

            if (sortMode !== undefined) {
                localVarQueryParameter['sortMode'] = sortMode;
            }

            if (priceRange) {
                localVarQueryParameter['priceRange'] = priceRange;
            }

            if (brandIds) {
                localVarQueryParameter['brandIds'] = brandIds;
            }

            if (categoryIds) {
                localVarQueryParameter['categoryIds'] = categoryIds;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Поиск товаров по бренду
         * @param {number} brandId 
         * @param {number} page 
         * @param {number} pageSize 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        poizonApiControllerSearchByBrandId: async (brandId: number, page: number, pageSize: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'brandId' is not null or undefined
            assertParamExists('poizonApiControllerSearchByBrandId', 'brandId', brandId)
            // verify required parameter 'page' is not null or undefined
            assertParamExists('poizonApiControllerSearchByBrandId', 'page', page)
            // verify required parameter 'pageSize' is not null or undefined
            assertParamExists('poizonApiControllerSearchByBrandId', 'pageSize', pageSize)
            const localVarPath = `/poizon-api/search-by-brand`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication x-api-key required
            await setApiKeyToObject(localVarHeaderParameter, "x-api-key", configuration)

            // authentication accessToken required

            // authentication x-service-api-key required
            await setApiKeyToObject(localVarHeaderParameter, "x-service-api-key", configuration)

            if (brandId !== undefined) {
                localVarQueryParameter['brandId'] = brandId;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['pageSize'] = pageSize;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * PoizonApiApi - functional programming interface
 * @export
 */
export const PoizonApiApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = PoizonApiApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Получение списка брендов
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async poizonApiControllerGetBrandList(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BrandListResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.poizonApiControllerGetBrandList(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PoizonApiApi.poizonApiControllerGetBrandList']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Получение информации о товаре
         * @param {number} spuId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async poizonApiControllerGetProductInfo(spuId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ProductInfoResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.poizonApiControllerGetProductInfo(spuId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PoizonApiApi.poizonApiControllerGetProductInfo']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Получение размерной сетки
         * @param {number} spuId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async poizonApiControllerGetSizeTable(spuId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SizeTableResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.poizonApiControllerGetSizeTable(spuId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PoizonApiApi.poizonApiControllerGetSizeTable']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Поиск товаров
         * @param {string} [keyword] Search keyword (full-text по названиям). Опционально — можно искать только по brandIds/categoryIds.
         * @param {number} [page] Page number
         * @param {number} [pageSize] Page size
         * @param {Array<number>} [fitIds] Fit IDs
         * @param {PoizonApiControllerSearchSortTypeEnum} [sortType] 
         * @param {PoizonApiControllerSearchSortModeEnum} [sortMode] Sort mode
         * @param {Array<number>} [priceRange] Price range (min, max)
         * @param {Array<number>} [brandIds] Brand IDs
         * @param {Array<number>} [categoryIds] Category IDs
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async poizonApiControllerSearch(keyword?: string, page?: number, pageSize?: number, fitIds?: Array<number>, sortType?: PoizonApiControllerSearchSortTypeEnum, sortMode?: PoizonApiControllerSearchSortModeEnum, priceRange?: Array<number>, brandIds?: Array<number>, categoryIds?: Array<number>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SearchResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.poizonApiControllerSearch(keyword, page, pageSize, fitIds, sortType, sortMode, priceRange, brandIds, categoryIds, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PoizonApiApi.poizonApiControllerSearch']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Поиск товаров по бренду
         * @param {number} brandId 
         * @param {number} page 
         * @param {number} pageSize 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async poizonApiControllerSearchByBrandId(brandId: number, page: number, pageSize: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SearchResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.poizonApiControllerSearchByBrandId(brandId, page, pageSize, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PoizonApiApi.poizonApiControllerSearchByBrandId']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * PoizonApiApi - factory interface
 * @export
 */
export const PoizonApiApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = PoizonApiApiFp(configuration)
    return {
        /**
         * 
         * @summary Получение списка брендов
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        poizonApiControllerGetBrandList(options?: RawAxiosRequestConfig): AxiosPromise<BrandListResponseDto> {
            return localVarFp.poizonApiControllerGetBrandList(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Получение информации о товаре
         * @param {number} spuId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        poizonApiControllerGetProductInfo(spuId: number, options?: RawAxiosRequestConfig): AxiosPromise<ProductInfoResponseDto> {
            return localVarFp.poizonApiControllerGetProductInfo(spuId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Получение размерной сетки
         * @param {number} spuId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        poizonApiControllerGetSizeTable(spuId: number, options?: RawAxiosRequestConfig): AxiosPromise<SizeTableResponseDto> {
            return localVarFp.poizonApiControllerGetSizeTable(spuId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Поиск товаров
         * @param {string} [keyword] Search keyword (full-text по названиям). Опционально — можно искать только по brandIds/categoryIds.
         * @param {number} [page] Page number
         * @param {number} [pageSize] Page size
         * @param {Array<number>} [fitIds] Fit IDs
         * @param {PoizonApiControllerSearchSortTypeEnum} [sortType] 
         * @param {PoizonApiControllerSearchSortModeEnum} [sortMode] Sort mode
         * @param {Array<number>} [priceRange] Price range (min, max)
         * @param {Array<number>} [brandIds] Brand IDs
         * @param {Array<number>} [categoryIds] Category IDs
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        poizonApiControllerSearch(keyword?: string, page?: number, pageSize?: number, fitIds?: Array<number>, sortType?: PoizonApiControllerSearchSortTypeEnum, sortMode?: PoizonApiControllerSearchSortModeEnum, priceRange?: Array<number>, brandIds?: Array<number>, categoryIds?: Array<number>, options?: RawAxiosRequestConfig): AxiosPromise<SearchResponseDto> {
            return localVarFp.poizonApiControllerSearch(keyword, page, pageSize, fitIds, sortType, sortMode, priceRange, brandIds, categoryIds, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Поиск товаров по бренду
         * @param {number} brandId 
         * @param {number} page 
         * @param {number} pageSize 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        poizonApiControllerSearchByBrandId(brandId: number, page: number, pageSize: number, options?: RawAxiosRequestConfig): AxiosPromise<SearchResponseDto> {
            return localVarFp.poizonApiControllerSearchByBrandId(brandId, page, pageSize, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * PoizonApiApi - object-oriented interface
 * @export
 * @class PoizonApiApi
 * @extends {BaseAPI}
 */
export class PoizonApiApi extends BaseAPI {
    /**
     * 
     * @summary Получение списка брендов
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PoizonApiApi
     */
    public poizonApiControllerGetBrandList(options?: RawAxiosRequestConfig) {
        return PoizonApiApiFp(this.configuration).poizonApiControllerGetBrandList(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Получение информации о товаре
     * @param {number} spuId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PoizonApiApi
     */
    public poizonApiControllerGetProductInfo(spuId: number, options?: RawAxiosRequestConfig) {
        return PoizonApiApiFp(this.configuration).poizonApiControllerGetProductInfo(spuId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Получение размерной сетки
     * @param {number} spuId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PoizonApiApi
     */
    public poizonApiControllerGetSizeTable(spuId: number, options?: RawAxiosRequestConfig) {
        return PoizonApiApiFp(this.configuration).poizonApiControllerGetSizeTable(spuId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Поиск товаров
     * @param {string} [keyword] Search keyword (full-text по названиям). Опционально — можно искать только по brandIds/categoryIds.
     * @param {number} [page] Page number
     * @param {number} [pageSize] Page size
     * @param {Array<number>} [fitIds] Fit IDs
     * @param {PoizonApiControllerSearchSortTypeEnum} [sortType] 
     * @param {PoizonApiControllerSearchSortModeEnum} [sortMode] Sort mode
     * @param {Array<number>} [priceRange] Price range (min, max)
     * @param {Array<number>} [brandIds] Brand IDs
     * @param {Array<number>} [categoryIds] Category IDs
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PoizonApiApi
     */
    public poizonApiControllerSearch(keyword?: string, page?: number, pageSize?: number, fitIds?: Array<number>, sortType?: PoizonApiControllerSearchSortTypeEnum, sortMode?: PoizonApiControllerSearchSortModeEnum, priceRange?: Array<number>, brandIds?: Array<number>, categoryIds?: Array<number>, options?: RawAxiosRequestConfig) {
        return PoizonApiApiFp(this.configuration).poizonApiControllerSearch(keyword, page, pageSize, fitIds, sortType, sortMode, priceRange, brandIds, categoryIds, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Поиск товаров по бренду
     * @param {number} brandId 
     * @param {number} page 
     * @param {number} pageSize 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PoizonApiApi
     */
    public poizonApiControllerSearchByBrandId(brandId: number, page: number, pageSize: number, options?: RawAxiosRequestConfig) {
        return PoizonApiApiFp(this.configuration).poizonApiControllerSearchByBrandId(brandId, page, pageSize, options).then((request) => request(this.axios, this.basePath));
    }
}

/**
 * @export
 */
export const PoizonApiControllerSearchSortTypeEnum = {
    NUMBER_0: 0,
    NUMBER_1: 1,
    NUMBER_3: 3,
    NUMBER_4: 4
} as const;
export type PoizonApiControllerSearchSortTypeEnum = typeof PoizonApiControllerSearchSortTypeEnum[keyof typeof PoizonApiControllerSearchSortTypeEnum];
/**
 * @export
 */
export const PoizonApiControllerSearchSortModeEnum = {
    Asc: 'ASC',
    Desc: 'DESC'
} as const;
export type PoizonApiControllerSearchSortModeEnum = typeof PoizonApiControllerSearchSortModeEnum[keyof typeof PoizonApiControllerSearchSortModeEnum];
